import parser from 'html-react-parser';

export const SAE_TEXT = `
  <p>
    En caso se exceda el tiempo, comunícate con
    <a href="https://api.whatsapp.com/send?phone=51960252970&text=Hola%2C%20soy%20alumno%20UTP%20y%20deseo%20hacer%20una%20consulta"
      target="_blank"
      style="color: #5B36F2; font-weight: 700;"
      rel="noreferrer">
      SAE
    </a>.
  </p>
`;

export const renderCommentary = (comentary: string | JSX.Element) =>
  typeof comentary === 'string' ? parser(comentary) : comentary;
